/** UI 공통 테마. 색은 원작 상태바/아이템창 색감을 참고했다. */

export const UI_FONT = "'Malgun Gothic','Apple SD Gothic Neo','Noto Sans KR',sans-serif";
export const UI_MONO = "'DejaVu Sans Mono',Menlo,Consolas,monospace";

export const COLOR = {
  panel: 0x191924,
  panelEdge: 0x0c0c12,
  panelLight: 0x2e2e3e,
  track: 0x0d0d12,
  hp: 0xf24949,
  hpLight: 0xff8a7a,
  mp: 0x3c8ef0,
  mpLight: 0x8fc8ff,
  exp: 0xf2c33c,
  expLight: 0xffe89a,
  window: 0xf2e4c4,
  windowDark: 0xd9c49b,
  windowEdge: 0x3a2a18,
  slot: 0xe4d3ae,
  slotEdge: 0xa78d62,
  tabActive: 0xf2e4c4,
  tabIdle: 0xbfa87c,
} as const;

export const TEXT_COLOR = {
  bright: '#ffffff',
  dim: '#b9b9c6',
  gold: '#ffd24a',
  dark: '#3a2a18',
  darkDim: '#6a5334',
  good: '#8ef2a0',
  warn: '#ffca6a',
} as const;
